import GlobeConst from '../../../../constants/globe.constant';
import { getServiceHostPreference } from '../../../../services/utils/getServiceHostPreference';

const getRadarApiUrlPrefix = () => `${getServiceHostPreference()}/${GlobeConst.radarRasterSourceBase}`;

export { getRadarApiUrlPrefix };
